module.exports = __webpack_public_path__ + "img/book6.b772c9d9.jpg";